import clonedeep from 'clone-deep'

class Transform {
    constructor(data) {
        this.data = clonedeep(data);
    }

    get(field = null) {
        if (field) return this.data[field];
        return this.data;
    }

    isObject(arg) {
        return arg !== null && typeof arg === 'object' && !(arg instanceof Array);
    }

    isArray(arg) {
        return arg !== null && typeof arg === 'object' && (arg instanceof Array) && Array.isArray(arg);
    }

    transform(schema, newKeys) {
        if (this.isObject(this.data)) this.transformObject(this.data, schema, newKeys);
        if (this.isArray(this.data)) this.transformArray(this.data, schema, newKeys);

        return this;
    }

    transformObject(data, schema, newKeys = {}) {
        for (const field in schema) {
            if (!schema.hasOwnProperty(field)) continue;
            let key = newKeys[field] || field;
            if (!this.isObject(schema[key])) {
                data[key] = schema[field].reduce((acc, curr) => curr(acc, data), data[field]);
                continue;
            }

            if (this.isObject(data[key])) data[key] = this.transformObject(data[key], schema[key])
            if (this.isArray(data[key])) data[key] = this.transformArray(data[key], schema[key])
        }

        return data;
    }

    transformArray(data, schema, newKeys = {}) {
        return data.map(item => this.transformObject(item, schema, newKeys))
    }
}

export default Transform;

export const jsonParse = data => data && JSON.parse(data)
